import { Component, inject } from '@angular/core'
import { AuthService } from 'src/app/services/auth.service'
import { IPermissionList } from '../../model/interfaces'
import { Router, RouterOutlet } from '@angular/router'
import { LayoutService } from './layout.service'
import { NzLayoutComponent, NzSiderComponent, NzHeaderComponent, NzContentComponent } from 'ng-zorro-antd/layout';
import { LogoComponent } from './logo/logo.component';
import { SliderMenuComponent } from './slider-menu/slider-menu.component';
import { HeaderComponent } from './header/header.component';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.sass'],
    imports: [
        NzLayoutComponent,
        NzSiderComponent,
        LogoComponent,
        SliderMenuComponent,
        NzHeaderComponent,
        HeaderComponent,
        NzContentComponent,
        RouterOutlet,
    ]
})
export class MainLayoutComponent {
  layoutService = inject(LayoutService)
  isCollapsed = inject(LayoutService).isCollapsed
  permissions?: IPermissionList
  get login() {
    return localStorage.getItem('login')
  }

  constructor(private auth: AuthService, private router: Router) {}

  logout() {
    this.auth.clearTokens()
    this.router.navigate(['/login']).then()
  }
}
